import { render, staticRenderFns } from "./PrecioProductoListadoComponent.vue?vue&type=template&id=03bb5e6d&"
import script from "./PrecioProductoListadoComponent.vue?vue&type=script&lang=js&"
export * from "./PrecioProductoListadoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports